import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  state() {
    return {
      cognitoSub: null,
      userId: null,
      email: null,
      idToken: null,
      accessToken: null,
      refreshToken: null,
      didAutoLogout: false,
      isAuthenticated: false,
      session: null,
      givenName: null,
      familyName: null,
      companyCode: null,
      companyName: null,
    };
  },
  mutations,
  actions,
  getters,
};
